import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-textcounter', 'remaining', 'characters');
Labels.set('ui-textcounter', 'invalid', 'Please use %d characters or fewer.');
